import { ListingWithDetails } from "../../../types";
import { CardLayout } from "../../../types/ui-types";
import { getItemTypeColor } from "../../../utils/colors";
import { Card } from "../Card/Card";
import "./ListingGrid.css";

type ListingGridProps = {
  listings: ListingWithDetails[];
  layoutType: CardLayout;
  isEditMode?: boolean;
  onEditListing?: (listing: ListingWithDetails) => void;
};

export const ListingGrid = ({
  listings,
  layoutType,
  isEditMode = false,
  onEditListing,
}: ListingGridProps) => {
  return (
    <div
      className={`listing-grid__container listing-grid__layout--${layoutType}`}
    >
      {listings.length > 0 ? (
        listings.map((listing) => (
          <Card
            key={listing.id}
            listingId={listing.id}
            listingUserId={listing.userId || ""}
            layoutType={layoutType}
            imageUrls={[listing.imageUrl || listing.coverImgUrl || ""]}
            title={listing.name}
            type={listing.subType}
            subTypeLabel={listing.subType || "other"}
            typeColor={getItemTypeColor(listing.itemType)}
            onClick={() => {
              window.location.href = `/${listing.itemType}s/${listing.id}`;
            }}
            editing={isEditMode}
            onEdit={onEditListing ? () => onEditListing(listing) : undefined}
          >
            <div className="card-location">{listing.locationName}</div>
            <div className="card-description">{listing.description}</div>
          </Card>
        ))
      ) : (
        <p className="listing-grid__no-listings">Nothing here yet!</p>
      )}
    </div>
  );
};
